module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools.c105d9c5.png";